import {
  NEW_ONBOARDING,
  SHOW_TOPBAR
} from '../actions/onBoardingActions';

import {
  RESET_ACCOUNT,
  LOG_OUT
} from '../actions/accountActions';

const initialState = {
  steps: null,
  count: null,
  showTopbar: false

} // END initialState

export default function (state = initialState, action) {
  let { payload } = action, newState;
  switch (action.type) {
      case NEW_ONBOARDING:
          newState = { steps: payload.data, count: payload.count || 0 };
          return { ...state, ...newState };

      case SHOW_TOPBAR:
          newState = { showTopbar: payload }
          return { ...state, ...newState };

      case RESET_ACCOUNT:
      case LOG_OUT:
          newState = { initialState }
          return { ...state, ...initialState };

      default:
          return state;

  } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/onBoardingReducer.js